module.exports = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  title: 'Tabs',
  type: 'object',
  properties: {
    attributes: {
      type: 'object',
      description:
        'A Drupal-style attributes object with extra attributes to append to this component.',
    },
    panels: {
      type: 'array',
      description:
        'All of the tab panels. Each panel should contain a label and content.',
      items: {
        type: 'object',
        properties: {
          label: {
            type: 'string',
            description: 'Tab label used in the navigation. Twig only.',
            default: 'Tab',
          },
          content: {
            type: ['string', 'object', 'array'],
            description: 'Tab panel content.',
          },
          selected: {
            type: 'boolean',
            description:
              'Set active state on tab. Only one active tab allowed at a time. Defaults to first tab.',
            default: false,
          },
          id: {
            type: 'string',
            description:
              'Unique identifier for each tab label, may be used for deep linking.',
          },
        },
      },
    },
    vertical_tabs: {
      description:
        'Makes tabs arranged vertically - one on top of the other and place them on the left or right side of the content.',
      type: 'string',
      enum: ['none', 'left', 'right'],
      default: 'none',
    },
    align: {
      description:
        'Tab labels alignment. Horizontally arranged tabs can be on the left, center or right. When tabs are vertical, they can be at the top, center, or bottom if the height of the content allows.',
      type: 'string',
      enum: ['start', 'center', 'end'],
      default: 'start',
    },
    label_spacing: {
      type: 'string',
      description: 'Set label spacing.',
      default: 'small',
      enum: ['small', 'medium'],
    },
    panel_spacing: {
      type: 'string',
      description: 'Set panel spacing.',
      default: 'small',
      enum: ['none', 'small', 'medium'],
    },
    inset: {
      type: 'string',
      description: 'Controls spacing placement on tab labels and panels.',
      default: 'auto',
      enum: ['auto', 'on', 'off'],
    },
    selected_tab: {
      type: 'integer',
      description:
        'Set selected tab by number. To select the second tab, set to 2.',
      default: 1,
      minimum: 1,
    },
  },
};
